var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPathUp = function SvgPathUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.85 6.21 8 1.36 3.15 6.21c-.33.33-.33.87 0 1.2s.87.33 1.2 0l2.8-2.8V14h1.7V4.61l2.8 2.8c.17.17.38.25.6.25s.44-.08.6-.25c.33-.33.33-.87 0-1.2"
  })));
};
export default SvgPathUp;